import { searchComponent } from "../commons"

export default (state, indexes) => {
  const { currentEditSlidePage, currentEditMessage } = state
  const { message_index, row_index, slide_page_index } = indexes
  // if !currentEditSlidePage return default state
  if (!currentEditSlidePage) {
    console.info("현재 수정하고있는 슬라이드 페이지가 없어 currentEditMessage에 업데이트 하지 못하였습니다. currentEditSlidePage -> ", currentEditSlidePage)
    return currentEditMessage
  }

  const procCallBack = (component) => {
    return currentEditSlidePage
  }

  const updatedMessages = searchComponent(procCallBack, currentEditMessage, message_index, row_index, slide_page_index)
  
  return updatedMessages
}